import request from 'utils/request'
import { MCAAS020NewsRequest } from 'types/MCAAS020/MCAAS020NewsRequest'
export const initRequest = (params: MCAAS020NewsRequest) =>
  request({
    url: '/MCAAS020/init',
    method: 'post',
    data: params,
  })
